import API from './axios.js';


export const saveLabel = (labelData) => API.post('label', labelData);
export const getLabelsByUser = (queryParams = '') => API.get(`label${queryParams}`);
export const getLabelsByID = (labelId) => API.get(`label/${labelId}`);
export const getLabelsByCourtref = (courtRef) => API.get(`label/label-by-court-ref?courtRef=/${courtRef}`);
export const updateLabel = (labelId , labelData ) => API.patch(`label/${labelId}`,labelData);
export const deleteLabel = (id) => API.delete(`label/${id}`);


export const saveGlobalLabel = (labelData) => API.post('global-settings/label', labelData);
export const getGlobalLabelsByUser = (queryParams = '') => API.get(`global-settings/label${queryParams}`);
export const getGlobalLabelsByID = (labelId) => API.get(`global-settings/label/${labelId}`);
export const updateGlobalLabel = (labelId , labelData ) => API.patch(`global-settings/label/${labelId}`,labelData);
export const deleteGlobalLabel = (id) => API.delete(`global-settings/label/${id}`);